import { AsideMenuActionItem } from "./AsideMenuActionItem";
import { FetchStatus } from "../../../base/types";
import { Spinner } from "../../../widgets";
import { useDashboardPage } from "../../../providers";

export const AsideMenuActions = () => {
    const { page, status } = useDashboardPage();

    if (status === FetchStatus.Loading)
        return <Spinner />

    if (!page || !page.actions)
        return <></>

    return <>
        {page.actions.map(action => <AsideMenuActionItem
            key={action.actionId}
            className={'fs-7'}
            action={action} />)}
    </>
}